export default "__VITE_ASSET__Dn$rSqOK__"